import {TasksViewAppSettings} from "../../../../core/@types"
import {SettingsVersion} from "../../../../../common/settings-manager"
import {DEFAULT_TEMPLATE_ID} from "../../../../../../manager/app-settings/app-settings"
import tasksView_settingConverter_V2ToV3 from "../../../../core/settings/converter/v2-to-v3"
import table_settingConverter_V2ToV3 from "./v2-to-v3"

// const debug = "table_convertSettings"
const debug = false

export default function table_convertSettings(appSettingsConfig: TasksViewAppSettings) {
    let res = _.cloneDeep(appSettingsConfig)

    debug && console.log(debug, 'process start', _.cloneDeep(appSettingsConfig))

    // ensure version number exists (default to VERSION_1 if missing)
    const version = res.version || SettingsVersion.VERSION_1

    /** --- if version is older than VERSION_2, apply V1 to V2 conversion --- **/
    if (version < SettingsVersion.VERSION_2) {
        debug && console.log(debug, 'process: apply V1 to V2 conversion')

        // no changes required
    }

    /** --- if version is older than VERSION_3, apply V2 to V3 conversion --- **/
    if (version < SettingsVersion.VERSION_3) {
        // For new views appSettings.templateId is set to DEFAULT_TEMPLATE_ID.
        // If appSettings are empty then default template should be used.
        if (_.isEmpty(res)) {
            res = {
                templateId: DEFAULT_TEMPLATE_ID
            }
        }

        debug && console.log(debug, 'process: apply V2 to V3 conversion')
        tasksView_settingConverter_V2ToV3(res)
        table_settingConverter_V2ToV3(res)
    }

    debug && console.log(debug, 'process end', res)

    return res
}